<template>
  <v-app-bar
    id="app-bar"
    absolute
    app
    color="#fff !important"
    flat
    height="45"
    class="set-content"
    style="left: 80px"
  >
    <!-- <common-breadcrumb class="font-weight-light mobile-hidden"
                       :breadcrumb="_.get($route, 'meta.breadcrumb', [])"/> -->
    <div class="d-flex">
      <span style="cursor: pointer;" class="mx-2 d-flex" @click="backHome()">
        <svg v-if="routeNotification === 'blended'" xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none" class="my-auto mb-1">
          <path d="M6.09615 13.8549V11.8103C6.09614 11.2922 6.51744 10.8713 7.03928 10.868H8.9554C9.47957 10.868 9.9045 11.2899 9.9045 11.8103V13.849C9.90449 14.2983 10.2697 14.6636 10.7223 14.6668H12.0295C12.6401 14.6684 13.2262 14.4287 13.6584 14.0006C14.0907 13.5726 14.3337 12.9913 14.3337 12.3852V6.57739C14.3336 6.08775 14.115 5.6233 13.7367 5.30916L9.29564 1.78301C8.51933 1.16624 7.41057 1.18617 6.65725 1.83042L2.31167 5.30916C1.91549 5.61404 1.67869 6.07987 1.66699 6.57739V12.3793C1.66699 13.6426 2.69858 14.6668 3.97111 14.6668H5.24852C5.46644 14.6684 5.67598 14.5835 5.83064 14.4311C5.9853 14.2787 6.07228 14.0713 6.07227 13.8549H6.09615Z" fill="#5570F1"/>
        </svg>
        <strong v-else>Chi tiết học viên</strong>
      </span>
      <span v-if="routeNotification === 'blended'">/ <span class="mx-2">{{studentBlendedTutorDetail && studentBlendedTutorDetail.full_name ? studentBlendedTutorDetail.full_name : 'Chưa xác định'}}</span></span>
      <strong v-else>> <span class="mx-2">{{childCustomerName ? childCustomerName : 'Chưa xác định'}}</span></strong>
    </div>
    <div class="d-flex" style="margin-top:8px" >
      <div class="d-flex">
        <span class="m-auto mx-5" style="margin-top:8px;color: #000;">Chọn thời gian</span>
        <common-range-picker
          v-if="routeNotification === 'blended'"
          width="200px"
          :clearable="true"
          :aLight="'right'"
          :noneMargin="true"
          formatdate="DD/MM/YYYY"
          v-model="filterForm.dateTime"
          class="show-date disable-x"
          label=""
        ></common-range-picker>
        <common-range-picker
          v-else
          width="200px"
          :clearable="true"
          :aLight="'right'"
          :noneMargin="true"
          formatdate="DD/MM/YYYY"
          v-model="filterFormDou.dateTime"
          class="show-date disable-x"
          label=""
        ></common-range-picker>
      </div>
      <div class="d-flex">
        <span class="m-auto mx-5"  style="margin-top:8px;color: #000;">Loại view</span>
        <v-autocomplete
          v-if="routeNotification === 'blended'"
          v-model="filterForm.viewType"
          :items="items"
          item-text="text"
          item-value="id"
          label
          class="custome-bottom"
        />
        <v-autocomplete
          v-else
          v-model="filterFormDou.typeViewFilter"
          :items="typeFilter"
          item-text="name"
          item-value="code"
          label
          class="custome-bottom"
        />
      </div>
    </div>
    <div>
      <v-menu
        bottom
        left
        min-width="400"
        offset-y
        origin="top right"
        transition="scale-transition"
      >
        <template v-slot:activator="{ attrs, on }">
          <v-btn
            min-width="0"
            text
            v-bind="attrs"
            v-on="on"
            small
            style="position: relative;"
            @click="noReadTotal = 0"
          >
            <v-icon class="appbar-icon">mdi-bell</v-icon>
            <div v-if="noReadTotal" class="total-notice">{{noReadTotal}}</div>
          </v-btn>
        </template>

        <v-list
          :tile="false"
          flat
          nav
        >
          <ListNoticeTask :updatelist="noReadTotal" />
        </v-list>
      </v-menu>
      <v-menu
        bottom
        left
        min-width="200"
        offset-y
        origin="top right"
        transition="scale-transition"
      >
        <template v-slot:activator="{ attrs, on }">
          <v-btn min-width="0" text v-bind="attrs" v-on="on" small>
            <v-icon class="appbar-icon">mdi-account</v-icon>
          </v-btn>
        </template>

        <v-list :tile="false" flat nav>
          <app-bar-item to="/profile">
            <v-list-item-title v-text="'My profile'" />
          </app-bar-item>
          <v-divider class="mb-2 mt-2" />
          <a class="d-block btn-logout" @click="logout"> Logout </a>
        </v-list>
      </v-menu>
      <video
        id="my-video"
        autoplay
        style="display: none"
        src="https://web1.caresoft.vn/images/320x240.ogg"
      ></video>
      <video
        id="peer-video"
        autoplay
        style="display: none"
        src="https://web1.caresoft.vn/images/320x240.ogg"
      ></video>
      <common-voice-call />
      <common-voice-call-incoming />
      <common-voice-call-incoming-care-soft />
      <TriggerTaskPopupCreateAndEditTask/>
      <NoticeTodos :task="taskComming" :showModal="showModal" @closeModal="showModal = false" @openModal="showDetailTodo" />
    </div>
  </v-app-bar>
</template>

<script>
// Components
import { VHover, VListItem } from 'vuetify/lib';

import { mapState, mapMutations, mapActions } from 'vuex';

// Utilities
import { TYPE_CURRICULUM_OBJ } from '@/helpers/constant';
import BlendedCareRepository from '@/services/BlendedCareRepository';
import TriggerTaskPopupCreateAndEditTask from '@/components/trigger_task/PopupCreateAndEditTask.vue';
import StudentCareServices from '@/services/StudentCareServices';
import ListNoticeTask from '@/components/trigger_task/ListNoticeTask.vue';
import NoticeTodos from '@/components/trigger_task/NoticeTodos.vue';
import TokenService from '../../helpers/token';
import { downloadFile } from '../../helpers/utils';

export default {
  name: 'DashboardCoreAppBar',
  components: {
    AppBarItem: {
      render(h) {
        return h(VHover, {
          scopedSlots: {
            default: ({ hover }) => h(
              VListItem,
              {
                attrs: this.$attrs,
                class: {
                  'black--text': !hover,
                  'white--text primary elevation-12': hover,
                },
                props: {
                  activeClass: '',
                  dark: hover,
                  link: true,
                  ...this.$attrs,
                },
              },
              this.$slots.default,
            ),
          },
        });
      },
    },
    TriggerTaskPopupCreateAndEditTask,
    ListNoticeTask,
    NoticeTodos,
  },

  props: {
    value: {
      type: Boolean,
      default: false,
    },
  },

  data: () => ({
    dataAppointment: {},
    showConfirm: false,
    appointmentIds: [],
    profile: [{ title: 'Profile' }, { divider: true }, { title: 'Log out' }],
    totalItem: 0,
    appointments: [],
    hideNotifications: [],
    notificationPosition: [],
    remindContact: [],
    announcements: [],
    marqueeWidth: '60%',
    items: [{ id: 'table', text: 'Bảng' }, { id: 'chart', text: 'Biểu đồ' }],
    typeFilter: [{ name: 'Details', code: 'detail' }, { name: 'Chart', code: 'chart' }],
    taskComming: {},
    showModal: false,
    resetList: false,
    noReadTotal: 0,
  }),

  computed: {
    ...mapState(['drawer']),
    ...mapState('student_detail_bt', ['filterForm', 'studentBlendedTutorDetail']),
    ...mapState('duo_care', ['filterFormDou', 'childCustomerName']),
    routeNotification() {
      const result = this.$route.name === 'StudentDetailBlended' ? 'blended' : 'dou';
      return result;
    },
  },
  created() {
    let socket = false;
    const self = this;
    const user = TokenService.getUser();
    this.getTotalNoReadNotice();
    if (_.isObject(user) && _.size(user)) {
      const username = _.get(user, 'username');
      /* eslint-disable */
      socket = require("socket.io-client")(
        process.env.VUE_APP_NOTIFICATION_SOCKET_URL,
        { path: `${process.env.VUE_APP_NOTIFICATION_SOCKET_PATH}/socket.io` }
      );
      /* eslint-enable */
      socket.on('connect', () => {
        console.log('connect', username);
        socket.emit('user_join', { username });
      });
      socket.on(`reminder_task_${user.id}`, (res) => {
        console.log('reminder_task', res);
        this.taskComming = res;
        this.showModal = true;
        setTimeout(() => {
          this.showModal = false;
        }, 7000);
      });
      socket.on(`new_notification_${user.id}`, (res) => {
        console.log('new_notification', res);
        this.getTotalNoReadNotice();
      });
      socket.on('cc_client_export_success', (res) => {
        self
          .$swal({
            title: 'Đã export thành công!',
            confirmButtonText: 'Download',
          })
          .then(() => {
            downloadFile(
              _.get(res, 'filePath', ''),
              _.get(res, 'fileName', ''),
            );
          });
      });
    }

    Bus.$on('download-excel-filter', (filterForm) => {
      this.getDownloadExcels(filterForm);
    });
  },
  mounted() {
    this.filterForm.dateTime = this.generateStartDateAndEndDateForCurrentMonth();
    this.filterFormDou.dateTime = this.generateStartDateAndEndDateBefore30Days();
  },
  watch: {
    filterForm: {
      deep: true,
      handler() {
        this.getDataDiligenceByID();
      },
    },
  },
  methods: {
    ...mapMutations({
      setDrawer: 'SET_DRAWER',
    }),
    ...mapActions('student_care', ['exportData']),
    closeModalCall() {
      this.showModal = false;
      this.mobile = '';
      this.appointmentId = 0;
    },
    ...mapMutations('login', ['SET_USER']),
    logout() {
      TokenService.removeRefreshToken();
      TokenService.removeToken();
      TokenService.removeUser();
      TokenService.removePermissions();
      this.SET_USER(null);
      this.$router.push('/login');
    },
    resetCount() {
      this.countNews = 0;
    },
    returnHome() {
      if (this.checkAuthorization('operator_read')) {
        this.$router.push('/tutor/operational-activities');
      } else if (this.checkAuthorization('interviewer_read')) {
        this.$router.push('/tutor/operational-work');
      } else {
        this.$router.push('/tutor-test');
      }
    },
    getDownloadExcels(filterForm) {
      const loader = this.$loading.show();
      this.exportData(filterForm)
        .then(() => {
          this.$swal({
            type: 'success',
            title: 'Export data thành công',
            text: 'Dữ liệu đang được xử lý, sẽ thông báo sau khi kết thúc!',
          });
          loader.hide();
        })
        .catch(() => {
          this.$swal({
            type: 'error',
            title: 'Lỗi',
            text: 'Dữ liệu bị lỗi xử lý!',
          });
          loader.hide();
        });
    },
    formatDate(date) {
      const year = date.getFullYear();
      const month = (date.getMonth() + 1).toString().padStart(2, '0'); // Months are zero-based, so add 1
      const day = date.getDate().toString().padStart(2, '0');
      return `${year}-${month}-${day}`;
    },

    generateStartDateAndEndDateForCurrentMonth() {
      const today = new Date();
      const currentYear = today.getFullYear();
      const currentMonth = today.getMonth(); // Months are zero-based

      // Get the first day of the current month
      const startDate = new Date(currentYear, currentMonth, 1);

      // Get the current date
      const endDate = today;

      const formattedStartDate = this.formatDate(startDate);
      const formattedEndDate = this.formatDate(endDate);

      return [formattedStartDate, formattedEndDate];
    },
    generateStartDateAndEndDateBefore30Days() {
      const today = new Date();
      const currentYear = today.getFullYear();
      const currentMonth = today.getMonth(); // Months are zero-based
      const currentDay = today.getDate();

      // Get the first day of the current month
      const startDate = new Date(currentYear, currentMonth, currentDay - 30);

      // Get the current date
      const endDate = today;

      const formattedStartDate = this.formatDate(startDate);
      const formattedEndDate = this.formatDate(endDate);

      return [formattedStartDate, formattedEndDate];
    },
    backHome() {
      this.$router.push(`/blended-care/periodically-care-student?typeCurriculum=${TYPE_CURRICULUM_OBJ.ONLINE}&schoolLevel=${this.$route.query.schoolLevel}`);
    },
    ...mapActions('student_detail_bt', ['setListDiligence']),
    async getDataDiligenceByID() {
      this.loading = true;
      if (this.studentBlendedTutorDetail && this.studentBlendedTutorDetail.lms_core_user_id) {
        const params = {
          id: this.studentBlendedTutorDetail.lms_core_user_id,
          startTime: this.filterForm.dateTime[0],
          endTime: this.filterForm.dateTime[1],
        };
        const res = await BlendedCareRepository.getListDiligence(params);
        if (res && res.data) {
          this.setListDiligence(res.data);
        }
        if (res && res.errors) {
          this.$swal({
            title: 'Lỗi!',
            text: 'Có lỗi xảy ra. Vui Lòng thử lại !!!',
          });
        }
      }
      this.loading = false;
    },
    showDetailTodo() {
      const params = { ids: JSON.parse(this.taskComming.taskIds).join(',') };
      const routeData = this.$router.resolve({ path: '/student-care/tutor-task', query: { typeCurriculum: 'online', ids: params.ids } });
      window.open(routeData.href, '_blank');
    },
    async getTotalNoReadNotice() {
      const res = await StudentCareServices.getTotalNoReadNocification();
      if (res && res.data) {
        this.noReadTotal = res.data.count;
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.notification-has-0 {
  .v-badge__badge {
    display: none;
  }
}

.notification-has-1 {
  .v-badge__badge {
    display: inline-block;
  }
}

.padding-10 {
  padding: 10px;
}

.v-messages__message {
  color: #ff5252 !important;
  caret-color: #ff5252 !important;
}

.appbar-icon {
  font-size: 22px !important;
}

.theme--dark {
  .v-list-item__title {
    .notification {
      .notification-info {
        background-color: #e91e63;

        .notification-item {
          .v-icon {
            color: white;
          }
        }
      }
    }
  }
}

.notification-info {
  background-color: #f1f1f1;
  padding: 5px 10px;

  .notification-item {
    .v-icon {
      color: #a847bf;
    }
  }
}

.notification-header {
  padding: 5px 15px;
  color: #a847bf;
}

.no-outline:focus {
  outline: unset;
}

.hiden-person-result {
  display: none;
}

.announcement-container {
  display: flex;
  background-color: white;
  padding: 0px 10px;
  border-radius: 15px;

  marquee {
    font-size: 16px;
    font-weight: 400;

    .announcement-text {
      color: black;
      text-decoration: unset;
    }

    .announcement-text.has-link {
      cursor: pointer;
    }

    .announcement-text.has-link:hover {
      color: blue;
      text-decoration: underline;
      text-underline-position: below;
    }
  }
}
.total-notice {
  position: absolute;
  border-radius: 70%;
  color: #FFF;
  font-size: 10px;
  font-style: normal;
  font-weight: 400;
  background-color: #F14E4E;
  padding: 2px 4px;
  top: 5px;
  left: 12px;
}
</style>
<style lang="scss">
.set-content {
  .v-toolbar__content {
    justify-content: space-between !important;
  }
}
.custome-bottom {
  .v-select__slot {
    height: 25px;
    border-radius: 5px;
    border: 1px solid rgba(119, 119, 119, 0.20);
    background: #FFF;
    margin-top: 4px;
  }
    input{
        padding-top: 12px !important;
        padding-bottom: 0px !important;
        padding-left: 6px !important;
        font-size: 14px;
    }
    i {
      margin-bottom: 10px !important;
    }
}
.disable-x {
  button {
    display: none !important;
  }
}
</style>
